import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">

            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>

            </li>



            <li>
              <Link to="/clients" >
                <i className="bx bx-calendar"></i>
                <span>{props.t("Clients")}</span>
              </Link>
            </li>

            <li>
              <Link to="/teams" >
                <i className="bx bx-chat"></i>
                <span>{props.t("Team")}</span>
              </Link>
            </li>
            <li>
              <Link to="/billing" >
                <i className="bx bx-file"></i>
                <span>{props.t("Billing")}</span>
              </Link>
            </li>
            <li>
              <Link to="/subscription-plans" >
                <i className="bx bx-file"></i>
                <span>{props.t("Subscription plans")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" >
                <i className="bx bx-file"></i>
                <span>{props.t("Support")}</span>
              </Link>
            </li>
            <li>
              <Link to="#" className="has-arrow">
                <i className="bx bx-file"></i>
                <span>{props.t("Global settings")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="#" className="has-arrow">{props.t("Contact")}</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/setting/contact-level">{props.t("Contact Level")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/contact-status">{props.t("Contact Status")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/contact-type">{props.t("Contact Type")}</Link>
                      </li>
                      </ul>
                </li>
                <li>
                  <Link to="#" className="has-arrow">{props.t("Lead")}</Link>
                  <ul className="sub-menu">
                      <li>
                        <Link to="/setting/lead-source">{props.t("Lead Source")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/lead-status">{props.t("Lead Status")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/lead-type">{props.t("Lead Type")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/lead-stage">{props.t("Lead Stage")}</Link>
                      </li>
                      <li>
                          <Link to="/setting/question-answer">{props.t("Question Answer")}</Link>
                      </li>
                      </ul>
                </li>
                <li>
                  <Link to="#" className="has-arrow">{props.t("Pre-construction")}</Link>
                  <ul className="sub-menu">
                      <li>
                        <Link to="/setting/project-status">{props.t("Status")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/project-type">{props.t("Type")}</Link>
                      </li>
                      
                      </ul>
                </li>
                <li>
                  <Link to="#" className="has-arrow">{props.t("Clients")}</Link>
                  <ul className="sub-menu">
                      <li>
                        <Link to="/setting/transaction-type">{props.t("Transaction Type")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/transaction-status">{props.t("Transaction Status")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/transaction-ref">{props.t("Transaction Reference Type")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/listing-type">{props.t("Listing Type")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/listing-status">{props.t("Listing Status")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/service-type">{props.t("Service Type")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/deal-checklist">{props.t("Deal Checklist")}</Link>
                      </li>
                     <li>
                        <Link to="/setting/showing-status">{props.t("Showing Status")}</Link>
                     </li>
                      </ul>
                </li>
                  <li>
                        <Link to="#"  className="has-arrow">{props.t("Email")}</Link>

                   <ul className="sub-menu">
                      <li>
                       <Link to="/setting/email-target-list">{props.t("Email Target List")}</Link>
                      </li>
                       <li>
                        <Link to="/setting/email-list-type">{props.t("Email List Type")}</Link>
                      </li>
                    <li>
                        <Link to="/setting/email-target-type">{props.t("Email Target Type")}</Link>
                      </li>
                    <li>
                        <Link to="/setting/email-target-subtype">{props.t("Email Target Sub Type")}</Link>
                      </li>
                     
                      </ul>

                      </li>
                   <li>
                        <Link to="/setting/currency">{props.t("Currency")}</Link>
                      </li>
                  
                  
                    <li>
                        <Link to="/setting/field-definition">{props.t("Field Definition")}</Link>
                      </li>
                    <li>
                        <Link to="/setting/field-value">{props.t("Field Value")}</Link>
                      </li>
                    <li>
                        <Link to="/setting/help-category">{props.t("Help Category")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/localization">{props.t("Localization Resource")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/potential-listing-status">{props.t("Potential Listing Status")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/social-media">{props.t("Social Media Link Type")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/support-ticket-status">{props.t("Support Ticket Status")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/support-ticket-type">{props.t("Support Ticket Type")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/email-disclamer">{props.t("Email Disclaimer Template")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/email-notification-templates">{props.t("Email Notification Templates")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/system-timezone">{props.t("System Timezone")}</Link>
                      </li>
                      <li>
                        <Link to="/setting/agent-timezone">{props.t("Agent Timezone")}</Link>
                      </li>
                     
                </ul>
            </li>
            <li>
              <Link to="/setting/role" >
                <i className="bx bx-file"></i>
                <span>{props.t("Roles")}</span>
              </Link>
            </li>
            <li>
              <Link to="/logs-audits" >
                <i className="bx bx-file"></i>
                <span>{props.t("Logs & audits")}</span>
              </Link>
            </li>


          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
